export default "__VITE_ASSET__Bcyf8r_p__"